/* eslint-disable no-nested-ternary */
import React, { useState, useEffect } from 'react'
import PropTypes from 'prop-types'
import ExcelJS from 'exceljs'
// import moment from 'moment'
import {
  Row,
  Col,
  Button,
  FormControl,
  InputGroup,
  // ListGroup,
  ListGroupItem,
  Modal,
} from 'react-bootstrap'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import {
  faCircleChevronLeft,
  faCircleChevronRight,
} from '@fortawesome/free-solid-svg-icons'
import InfiniteScroll from 'react-infinite-scroll-component'
import apiService from '../services/apiServices'
import SelectBar from './SelectBar'

const wordSearch = (word, search) =>
  word && word.toLowerCase().includes(search.toLowerCase())

function SelectModal({ setting }) {
  const { show, erp, handleClose } = setting
  const [search, setsearch] = useState('')
  const [selected, setselected] = useState('')

  return (
    <Modal
      style={{
        zIndex: '999999999',
      }}
      show={show.show}
      onHide={() => handleClose()}
    >
      <Modal.Body>
        <h5>{show.id}</h5>
        <h5>{show.campaign_name}</h5>
        <div className="mb-2">
          <InputGroup
            style={{ borderRadius: '.25rem' }}
            className="m-2 w-90 border rounded-lg"
            size="sm"
          >
            <FormControl
              type="text"
              placeholder="Search ADM..."
              aria-label="Search ADM..."
              aria-describedby="btnGroupAddon"
              title="輸 入 關 鍵 字 搜 尋 專 案"
              value={search}
              onChange={(event) => setsearch(event.target.value)}
            />
          </InputGroup>
          <div
            className="scrollbarShow"
            style={{ maxHeight: '25rem', overflowY: 'auto' }}
          >
            {search
              ? erp
                  .filter((e) => wordSearch(e['專案名稱'], search))
                  .map((e) => (
                    <ListGroupItem
                      title={e['專案名稱']}
                      action
                      active={e['專案代號'] === selected['專案代號']}
                      className="px-3 py-2 App-oneLineEllipsis d-block"
                      key={e['專案代號']}
                      href=""
                      onClick={() => setselected(e)}
                    >
                      <Row>
                        <Col xs={4}>{e['專案代號']}</Col>
                        <Col xs={8}>{e['專案名稱']}</Col>
                      </Row>
                    </ListGroupItem>
                  ))
              : '請輸入搜尋文字'}
          </div>
        </div>
      </Modal.Body>
      <Modal.Footer>
        <Button
          style={{ boxShadow: 'none', color: '#317985' }}
          variant="secondary"
          onClick={() => handleClose()}
        >
          取消
        </Button>
        <Button
          variant="luca"
          onClick={() =>
            handleClose({
              [show.id]: selected,
            })
          }
          disabled={!selected}
        >
          確認
        </Button>
      </Modal.Footer>
    </Modal>
  )
}

function CostTable() {
  const [erp, seterp] = useState([])
  useEffect(() => {
    const getcostErp = async () => {
      const res = await apiService.data({
        path: `costErp`,
        method: 'get',
      })
      if (!res.error) seterp(res)
    }
    getcostErp()
  }, [])

  const [fix, setfix] = useState({})
  const [filter, setfilter] = useState({
    currency: '',
    month: '202407',
    mode: '',
    merge: '1',
  })
  const { month, currency, mode, merge } = filter
  const handleFilterChange = (e) =>
    setfilter({
      ...filter,
      [e.target.name]: e.target.value,
    })

  const [record, setrecord] = useState([])
  const getRecord = async (m) => {
    const res = await apiService.data({
      path: `calculate/${m}`,
      method: 'get',
    })
    if (!res.error) setrecord(res)
  }

  useEffect(() => {
    setrecord([])
    getRecord(month)
  }, [month])

  const fields = [
    { label: '驗收單號' },
    { label: '驗收日期' },
    { label: '預計付款日' },
    { label: '申請人員' },
    { label: '廠商代號' },
    { label: '部門' },
    { label: '付款條件' },
    { label: '付款方式' },
    { label: '申購單號', hide: true },
    { label: '專案代號' },
    { label: '備註' },
    { label: '狀態' },
    { label: '外部資料鍵值' },
    { label: '編號' },
    { label: '品名/規格' },
    { label: '說明' },
    { label: '專案代號' },
    { label: '專案分攤群組', hide: true },
    { label: '數量' },
    { label: '單位' },
    { label: '單價' },
    { label: '歸屬部門' },
    { label: '分攤群組', hide: true },
    { label: '財產類別' },
    { label: '外加/內含(稅)' },
    { label: '稅率' },
    { label: '幣別' },
    { label: '匯率' },
    { label: '原幣金額' },
    { label: '原幣稅額' },
    { label: '帳上金額' },
    { label: '帳上稅額' },
    { label: '工單製令', hide: true },
    { label: '會計科目' },
    { label: '資產編號', hide: true },
    { label: '憑證類別' },
    { label: '憑證部門' },
    { label: '發票號碼', hide: true },
    { label: '其他憑證號碼' },
    { label: '憑證日期' },
    { label: '扣抵種類' },
    { label: '外加稅' },
    { label: '銷售人' },
    { label: '銷售人統一編號', hide: true },
    { label: '資料所屬月份' },
    { label: '進口免稅貨物/勞務', hide: true },
    { label: '發票格式' },
    { label: '載具流水號', hide: true },
    { label: '扣抵代號' },
    { label: '課稅別' },
    { label: '備註', hide: true },
    { label: '業務別', hide: true },
    { label: '折退原因', hide: true },
    { label: '租任期別', hide: true },
    { label: 'WHT收入種類', hide: true },
    { label: 'WHT稅率(%)', hide: true },
    { label: 'WHT說明', hide: true },
    { label: 'WHT稅額', hide: true },
    { label: '銷售人公司地址', hide: true },
    { label: '海關代徵營業稅', hide: true },
    { label: '銷售人名稱', hide: true },
  ]

  const subfields = [
    { label: '免填' },
    { label: '以SOME+西元年月日六碼+流水號\n例如：SOME220831001續編' },
    { label: '媒體消耗月份最後一天' },
    { label: '作帳月份最後一天' },
    { label: '員編' },
    { label: 'A00002' },
    { label: '50400' },
    { label: 'PM30' },
    { label: 'T(固定)' },
    { label: '免填' },
    { label: '代公式' },
    { label: '20XX/XXMeta台幣' },
    { label: 'OPEN(固定)' },
    { label: '驗收單號後三碼' },
    { label: '' },
    { label: '詳閱附註公版頁籤' },
    { label: '公司名稱/廣告帳戶名稱' },
    { label: '案號' },
    { label: '免填' },
    { label: '1(固定)' },
    { label: 'SET(固定)' },
    { label: '帳單上數字' },
    { label: '' },
    { label: '免填' },
    { label: 'N(固定)' },
    { label: '2(固定)' },
    { label: '0(固定)' },
    { label: 'TWD' },
    { label: '1(固定)' },
    { label: '代公式' },
    { label: '代公式' },
    { label: '代公式' },
    { label: '代公式' },
    { label: '免填' },
    { label: '580401/6117' },
    { label: '免填' },
    { label: 'CERTIFICATE(固定)' },
    { label: '代公式' },
    { label: '免填' },
    { label: 'invoice號碼' },
    { label: '媒體消耗月份最後一天' },
    { label: 'F(固定)' },
    { label: 'Y(固定)' },
    { label: '代公式' },
    { label: '免填' },
    { label: '發票或invoice的月份' },
    { label: '免填' },
    { label: '22(固定)' },
    { label: '無須填寫' },
    { label: '3(固定)' },
    { label: '3(固定)' },
    { label: '免填' },
    { label: '免填' },
    { label: '免填' },
    { label: '免填' },
    { label: '免填' },
    { label: '免填' },
    { label: '免填' },
    { label: '免填' },
    { label: '免填' },
    { label: '免填' },
    { label: '免填' },
    { label: '免填' },
  ]

  // useEffect(() => {
  //   setFile([
  //     fields.filter((f) => !f.hide).map((f) => f.label),
  //     ...filteredrecord.map((record) =>
  //       fields.filter((f) => !f.hide).map((f) => record[f.label])
  //     ),
  //   ])
  // }, [filteredrecord])

  const [loaded, setloaded] = useState(50)
  const [fixing, setfixing] = useState(false)

  const [show, setshow] = useState(false)

  const merged = record.reduce((prev, cur) => {
    const mergeField = ['原幣稅額', '原幣金額', '單價', '帳上金額', '帳上稅額']
    if (
      cur['專案代號'] &&
      prev.find(
        (p) =>
          p.ad_account_id === cur.ad_account_id &&
          p['專案代號'] === cur['專案代號']
      )
    ) {
      const mergedItem = {
        ...prev.find(
          (p) =>
            p.ad_account_id === cur.ad_account_id &&
            p['專案代號'] === cur['專案代號']
        ),
      }
      mergeField.forEach((f) => {
        mergedItem[f] = parseFloat(mergedItem[f] + parseFloat(cur[f]))
      })
      return prev.map((p) =>
        p.ad_account_id === cur.ad_account_id &&
        p['專案代號'] === cur['專案代號']
          ? mergedItem
          : p
      )
    }
    return [...prev, cur]
  }, [])

  const createFile = async () => {
    const workbook = new ExcelJS.Workbook()
    const worksheet = workbook.addWorksheet(`META${month}${currency}對帳單`)
    const rows = [
      fields.map((f) => f.label),
      ...(merge ? merged : record)
        .filter((rf) => {
          const t = mode !== 'project' || !rf['專案代號']
          const c = !currency || rf['幣別'] === currency
          return t && c
        })
        .map((r) =>
          fields.map((f) =>
            fix[r.campaign_id] && fix[r.campaign_id][f.label]
              ? fix[r.campaign_id][f.label]
              : r[f.label]
          )
        ),
    ]
    rows.forEach((row) => worksheet.addRow(row))

    const file = await workbook.xlsx.writeBuffer({
      base64: true,
    })
    const data = new Blob([file], {
      type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
    })
    const url = URL.createObjectURL(data)
    const link = document.createElement('a')
    link.setAttribute('href', url)
    link.setAttribute('download', `消耗量.xlsx`)
    document.body.appendChild(link)
    link.click()
  }

  return (
    <>
      <Row
        className="text-lucaDark ps-1 flex-nowrap"
        style={{
          height: '12vh',
        }}
      >
        <Col
          xs={2}
          className="ps-3 d-flex"
          style={{
            zIndex: '100',
          }}
        >
          <span className="my-auto">月份：</span>
          <SelectBar
            setting={{
              id: 'defaultBorder',
              method: handleFilterChange,
              name: 'month',
              value: month,
              placeholder: '未選擇',
              content: [
                { name: '1月', value: '202401' },
                { name: '2月', value: '202402' },
                { name: '3月', value: '202403' },
                { name: '4月', value: '202404' },
                { name: '5月', value: '202405' },
                { name: '6月', value: '202406' },
                { name: '7月', value: '202407' },
                { name: '8月', value: '202408' },
                { name: '9月', value: '202409' },
                { name: '10月', value: '202410' },
                { name: '11月', value: '202411' },
              ],
            }}
          />
        </Col>
        <Col
          xs={2}
          className="ps-3 d-flex"
          style={{
            zIndex: '100',
          }}
        >
          <span className="my-auto">幣別：</span>
          <SelectBar
            setting={{
              id: 'defaultBorder',
              method: handleFilterChange,
              name: 'currency',
              value: currency,
              placeholder: '未選擇',
              content: [
                { name: 'TWD', value: 'TWD' },
                { name: 'USD', value: 'USD' },
              ],
            }}
          />
        </Col>
        <Col
          xs={2}
          className="ps-3 d-flex"
          style={{
            zIndex: '100',
          }}
        >
          <span className="my-auto text-nowrap">顯示：</span>
          <SelectBar
            setting={{
              id: 'defaultBorder',
              method: handleFilterChange,
              name: 'mode',
              value: mode,
              placeholder: '未選擇',
              content: [
                { name: '全部', value: '' },
                { name: '未自動對應到專案', value: 'project' },
                // { name: '金額不正確', value: 'money' },
              ],
            }}
          />
        </Col>
        <Col
          xs={2}
          className="ps-3 d-flex"
          style={{
            zIndex: '100',
          }}
        >
          <span className="my-auto">合併同專案：</span>
          <SelectBar
            setting={{
              id: 'defaultBorder',
              method: handleFilterChange,
              name: 'merge',
              value: merge,
              placeholder: '未選擇',
              content: [
                { name: '合併', value: '1' },
                { name: '不合併', value: '' },
              ],
            }}
          />
        </Col>
        <Col
          xs={2}
          className="ps-3 d-flex"
          style={{
            zIndex: '100',
          }}
        >
          <Button
            title="下 載"
            variant="outlined"
            className="m-auto"
            onClick={createFile}
            // disabled={!costs || costs.refreshing}
          >
            下載
          </Button>
        </Col>
      </Row>
      <Row
        className="text-lucaDark ps-1 overflow-hidden flex-nowrap"
        style={{
          height: '88vh',
        }}
      >
        {/* {fixing ? (
          <Col xs={6} className="position-relative">
            <Row
              className="p-0 mx-0 w-100 justift-content-end flex-nowrap"
              style={{
                height: '40px',
              }}
            >
              <Col xs={6} className="py-1 d-flex colBorder App-oneLineEllipsis">
                <span className="d-flex w-100 App-oneLineEllipsis pe-0">
                  活動名稱
                </span>
              </Col>
              <Col xs={6} className="py-1 d-flex colBorder App-oneLineEllipsis">
                <span className="d-flex w-100 App-oneLineEllipsis pe-0">
                  專案名稱
                </span>
              </Col>
            </Row>
            <InfiniteScroll
              dataLength={loaded}
              next={() => setloaded(loaded + 20)}
              hasMore={loaded < record.length}
              loader={<h4>Loading...</h4>}
              endMessage={<p />}
              scrollableTarget="scrollTarget"
            >
              {(merge ? merged : record)
                .filter((rf) => {
                  const t = mode !== 'project' || !rf['專案代號']
                  const c = !currency || rf['幣別'] === currency
                  return t && c
                })
                .slice(0, loaded)
                .map((rf, i) => (
                  <Row
                    key={i}
                    onClick={() =>
                      setshow({
                        show: true,
                        id: rf.campaign_id,
                        adaccount: rf.adaccount,
                        campaign_name: rf.campaign_name,
                      })
                    }
                    style={{
                      cursor: 'pointer',
                      backgroundColor: !rf['專案代號'] ? '#fac2c2' : '',
                    }}
                    className="p-0 mx-0 w-100 justift-content-end flex-nowrap hoverRow"
                  >
                    <Col
                      xs={6}
                      className="py-1 d-flex colBorder App-oneLineEllipsis"
                    >
                      {rf.campaign_name}
                    </Col>
                    <Col
                      xs={6}
                      className="py-1 d-flex colBorder App-oneLineEllipsis"
                    >
                      {fix[rf.campaign_id]
                        ? fix[rf.campaign_id]['專案名稱']
                        : rf['專案名稱']}
                    </Col>
                  </Row>
                ))}
            </InfiniteScroll>
            <FontAwesomeIcon
              className="position-absolute h5 text-luca"
              onClick={() => setfixing(false)}
              icon={faCircleChevronLeft}
              title="隱 藏 功 能 列"
              style={{
                cursor: 'pointer',
                top: '50%',
                right: '-10px',
                zIndex: '800',
              }}
            />
          </Col>
        ) : (
          <Col className="position-relative">
            <FontAwesomeIcon
              className="position-absolute h5 text-luca"
              onClick={() => setfixing(true)}
              icon={faCircleChevronRight}
              title="展 開 功 能 列"
              style={{
                cursor: 'pointer',
                top: '50%',
                right: '-10px',
                zIndex: '800',
              }}
            />
          </Col>
        )} */}

        {fixing ? (
          <Col xs={6} className="position-relative">
            <Row
              className="p-0 mx-0 w-100 justift-content-end flex-nowrap"
              style={{
                height: '40px',
              }}
            >
              <Col xs={6} className="py-1 d-flex colBorder App-oneLineEllipsis">
                <span className="d-flex w-100 App-oneLineEllipsis pe-0">
                  活動名稱
                </span>
              </Col>
              <Col xs={6} className="py-1 d-flex colBorder App-oneLineEllipsis">
                <span className="d-flex w-100 App-oneLineEllipsis pe-0">
                  專案名稱
                </span>
              </Col>
            </Row>
            {(merge ? merged : record)
              .filter((rf) => {
                const t = mode !== 'project' || !rf['專案代號']
                const c = !currency || rf['幣別'] === currency
                return t && c
              })
              .slice(0, loaded)
              .map((rf, i) => (
                <Row
                  key={i}
                  onClick={() =>
                    setshow({
                      show: true,
                      id: rf.campaign_id,
                      adaccount: rf.adaccount,
                      campaign_name: rf.campaign_name,
                    })
                  }
                  style={{
                    cursor: 'pointer',
                    backgroundColor: !rf['專案代號'] ? '#fac2c2' : '',
                  }}
                  className="p-0 mx-0 w-100 justift-content-end flex-nowrap hoverRow"
                >
                  <Col
                    xs={6}
                    className="py-1 d-flex colBorder App-oneLineEllipsis"
                  >
                    {rf.campaign_name}
                  </Col>
                  <Col
                    xs={6}
                    className="py-1 d-flex colBorder App-oneLineEllipsis"
                  >
                    {fix[rf.campaign_id]
                      ? fix[rf.campaign_id]['專案名稱']
                      : rf['專案名稱']}
                  </Col>
                </Row>
              ))}
            <FontAwesomeIcon
              className="position-absolute h5 text-luca"
              onClick={() => setfixing(false)}
              icon={faCircleChevronLeft}
              title="隱 藏 功 能 列"
              style={{
                cursor: 'pointer',
                top: '50%',
                right: '-10px',
                zIndex: '800',
              }}
            />
          </Col>
        ) : (
          <div
            className="position-relative h-100"
            style={{
              width: '1px',
            }}
          >
            <FontAwesomeIcon
              className="position-absolute h5 text-luca"
              onClick={() => setfixing(true)}
              icon={faCircleChevronRight}
              title="展 開 功 能 列"
              style={{
                cursor: 'pointer',
                top: '50%',
                right: '-10px',
                zIndex: '800',
              }}
            />
          </div>
        )}
        <Col
          id="scrollTarget"
          className="overflow-scroll scrollbarShow scrollbarShowBottom position-relative"
          style={{
            height: '88vh',
          }}
        >
          <Row
            className="p-0 mx-0 w-100 justift-content-end flex-nowrap"
            style={{
              height: '40px',
              position: 'sticky',
              top: '0px',
            }}
          >
            {fields
              .filter((f) => !f.hide)
              .map(({ label }, i) => (
                <Col
                  xs={2}
                  key={i}
                  className="py-1 d-flex colBorder App-oneLineEllipsis"
                >
                  <span className="d-flex w-100 App-oneLineEllipsis pe-0">
                    {label}
                  </span>
                </Col>
              ))}
          </Row>
          <Row
            className="p-0 mx-0 w-100 justift-content-end flex-nowrap"
            style={{
              height: '40px',
              position: 'sticky',
              top: '40px',
            }}
          >
            {fields
              .filter((f) => !f.hide)
              .map((f, i) => (
                <Col
                  xs={2}
                  key={i}
                  className="py-1 d-flex colBorder App-oneLineEllipsis"
                >
                  <span className="d-flex w-100 App-oneLineEllipsis pe-0">
                    {subfields[i].label}
                  </span>
                </Col>
              ))}
          </Row>
          <InfiniteScroll
            dataLength={loaded}
            next={() => setloaded(loaded + 20)}
            hasMore={loaded < record.length}
            loader={<h4>Loading...</h4>}
            endMessage={<p />}
            scrollableTarget="scrollTarget"
          >
            {(merge ? merged : record)
              .filter((rf) => {
                const t = mode !== 'project' || !rf['專案代號']
                const c = !currency || rf['幣別'] === currency
                return t && c
              })
              .slice(0, loaded)
              .map((rf, i) => (
                <Row
                  key={i}
                  className="p-0 mx-0 w-100 justift-content-end flex-nowrap"
                  style={{
                    backgroundColor: !rf['專案代號'] ? '#fac2c2' : '',
                  }}
                >
                  {fields
                    .filter((f) => !f.hide)
                    .map(({ label }, j) => (
                      <Col
                        key={`${i}_${j}`}
                        xs={2}
                        className="py-1 d-flex colBorder App-oneLineEllipsis"
                      >
                        {fix[rf.campaign_id] && fix[rf.campaign_id][label] ? (
                          <span className="d-flex App-oneLineEllipsis pe-0">
                            {fix[rf.campaign_id][label]}
                          </span>
                        ) : rf[label] ? (
                          <span className="d-flex App-oneLineEllipsis pe-0">
                            {rf[label]}
                          </span>
                        ) : (
                          <span className="App-oneLineEllipsis">- -</span>
                        )}
                      </Col>
                    ))}
                </Row>
              ))}
          </InfiniteScroll>
        </Col>
        <SelectModal
          setting={{
            show,
            erp,
            handleClose: (value) => {
              if (value)
                setfix({
                  ...fix,
                  ...value,
                })
              setshow('')
            },
          }}
        />
      </Row>
    </>
  )
}

SelectModal.propTypes = {
  setting: PropTypes.shape().isRequired,
}

export default CostTable
